import { ComponentProps } from "react";
import { TrimmedBreakingNewsArticle } from "@caas/types";
import Card from "@particles/card/Card";

/**
 * Returns the card props for the Template E v2 component.
 *
 * @param articles - The articles to be displayed in the component.
 * @param ref - The reference to be used for the link.
 * @returns {ComponentProps<typeof Card>[]} - The card props for the Template E v2 component.
 */
export const getBreakingNewsCard = (
  articles: TrimmedBreakingNewsArticle[]
): ComponentProps<typeof Card>[] => {
  const cardProps = articles
    .slice(0, 5) // Must only return maximum of 4 articles.
    .map(({ title, id, urlPath, paywall, edited, displaySetting }) => {
      const props: ComponentProps<typeof Card> = {
        id,
        title: displaySetting?.displayHeadline || title,
        link: urlPath,
        displayPaywall: paywall?.contentAccess === "1",
        editedTime: edited,
      };

      return props;
    });

  return JSON.parse(JSON.stringify(cardProps));
};
